import React from 'react';
import { capitalize } from 'lodash';
import { Box, Fade, Grid, GridSize, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { remCalc } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { GuessStates, GuessImgSrcMap } from 'types';

const t = (key: string) => translate('activities', key);

interface Props {
  guessIndicator: { id: string | null; status: string };
  sceneComponents: Array<{ data: any; label?: string }>;
  tileComponents: any[];
}

const GTheOrderRoundLayout: React.FC<Props> = ({
  guessIndicator,
  sceneComponents,
  tileComponents,
}) => {
  const gridItemLength = (12 / tileComponents.length || 1) as GridSize;
  const classes = styles();

  return (
    <Box style={{ position: 'relative' }}>
      <Grid container spacing={6} style={{ marginTop: remCalc(10) }}>
        {sceneComponents.map(({ data: SceneComponent, label }, index) => (
          <Grid key={index} item style={{ position: 'relative' }} xs={gridItemLength}>
            {label && (
              <Typography
                style={{ color: '#005D9F', fontWeight: 'bold', textAlign: 'center' }}
                variant="subtitle2"
              >
                {capitalize(label)}
              </Typography>
            )}
            <div className={classes.sceneContainers}>
              <SceneComponent />
            </div>
            <Fade in={guessIndicator.id === label && guessIndicator.status !== GuessStates.NULL}>
              <img
                alt={t('feedbackImg')}
                className={classes.feedbackImg}
                src={GuessImgSrcMap[guessIndicator.status]}
              />
            </Fade>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={6} style={{ marginTop: remCalc(32) }}>
        {tileComponents.map((TileComponent, index) => (
          <Grid key={index} item xs={gridItemLength}>
            <TileComponent />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

const styles = makeStyles(() => ({
  sceneContainers: {
    height: '100%',
    width: '100%',
    '& div': {
      height: '100%',
      width: '100%',
    },
  },
  feedbackImg: {
    left: 'calc(50% - 120px)',
    position: 'absolute',
    top: 'calc(50% - 120px)',
  },
}));

export default GTheOrderRoundLayout;
